/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesOffersDtosOfferPositionDto,
  FacilityFlowCoreModulesOffersWorkflowsAddOfferPositionRequest,
  FacilityFlowCoreModulesOffersWorkflowsAddOfferPositionResponse,
  FacilityFlowCoreModulesOffersWorkflowsCreateOfferPositionsFromTasksRequest,
  FacilityFlowCoreModulesOffersWorkflowsReorderOfferPositionsRequest,
  FacilityFlowCoreModulesOffersWorkflowsUpdateOfferPositionRequest
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getOfferPositions = () => {
/**
 * @summary Add a position to an offer (Draft only)
 */
const postApiV1OffersOfferIdPositions = (
    offerId: string,
    facilityFlowCoreModulesOffersWorkflowsAddOfferPositionRequest: FacilityFlowCoreModulesOffersWorkflowsAddOfferPositionRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersWorkflowsAddOfferPositionResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersWorkflowsAddOfferPositionResponse>(
      {url: `/api/v1/offers/${offerId}/positions`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOffersWorkflowsAddOfferPositionRequest
    },
      options);
    }
  /**
 * @summary Update a position on an offer (Draft only)
 */
const putApiV1OffersOfferIdPositionsPositionId = (
    offerId: string,
    positionId: string,
    facilityFlowCoreModulesOffersWorkflowsUpdateOfferPositionRequest: FacilityFlowCoreModulesOffersWorkflowsUpdateOfferPositionRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersDtosOfferPositionDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersDtosOfferPositionDto>(
      {url: `/api/v1/offers/${offerId}/positions/${positionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOffersWorkflowsUpdateOfferPositionRequest
    },
      options);
    }
  /**
 * @summary Remove a position from an offer (Draft only)
 */
const deleteApiV1OffersOfferIdPositionsPositionId = (
    offerId: string,
    positionId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/offers/${offerId}/positions/${positionId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Create positions from existing task definitions (Draft only)
 */
const postApiV1OffersOfferIdPositionsFromTasks = (
    offerId: string,
    facilityFlowCoreModulesOffersWorkflowsCreateOfferPositionsFromTasksRequest: FacilityFlowCoreModulesOffersWorkflowsCreateOfferPositionsFromTasksRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersWorkflowsAddOfferPositionResponse[]>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersWorkflowsAddOfferPositionResponse[]>(
      {url: `/api/v1/offers/${offerId}/positions/from-tasks`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOffersWorkflowsCreateOfferPositionsFromTasksRequest
    },
      options);
    }
  /**
 * @summary Reorder positions on an offer (Draft only)
 */
const putApiV1OffersOfferIdPositionsReorder = (
    offerId: string,
    facilityFlowCoreModulesOffersWorkflowsReorderOfferPositionsRequest: FacilityFlowCoreModulesOffersWorkflowsReorderOfferPositionsRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/offers/${offerId}/positions/reorder`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOffersWorkflowsReorderOfferPositionsRequest
    },
      options);
    }
  return {postApiV1OffersOfferIdPositions,putApiV1OffersOfferIdPositionsPositionId,deleteApiV1OffersOfferIdPositionsPositionId,postApiV1OffersOfferIdPositionsFromTasks,putApiV1OffersOfferIdPositionsReorder}};
export type PostApiV1OffersOfferIdPositionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOfferPositions>['postApiV1OffersOfferIdPositions']>>>
export type PutApiV1OffersOfferIdPositionsPositionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOfferPositions>['putApiV1OffersOfferIdPositionsPositionId']>>>
export type DeleteApiV1OffersOfferIdPositionsPositionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOfferPositions>['deleteApiV1OffersOfferIdPositionsPositionId']>>>
export type PostApiV1OffersOfferIdPositionsFromTasksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOfferPositions>['postApiV1OffersOfferIdPositionsFromTasks']>>>
export type PutApiV1OffersOfferIdPositionsReorderResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOfferPositions>['putApiV1OffersOfferIdPositionsReorder']>>>
